import TextField from "@mui/material/TextField";
import { ProfileFormData } from "./profile-form-data";
import { FieldError, UseFormRegister } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";

interface Props {
  register: UseFormRegister<ProfileFormData>;
  editMode: boolean;
  companyName: string | null | undefined;
  fieldError: FieldError | undefined;
}

export const ProfileCompany = (props: Props) => {
  const { register, editMode, companyName, fieldError } = props;
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <TextField
        {...register("companyName")}
        defaultValue={companyName}
        variant="filled"
        //when editMode is false, the field is disabled
        InputProps={{
          readOnly: !editMode,
          style: { backgroundColor: !editMode ? "white" : undefined },
        }}
        label={t("account.profilePage.companyLabel")}
        error={!!fieldError}
        helperText={fieldError?.message}
        fullWidth
      />
    </Box>
  );
};
